<template>
  <div>
    <b-row>
      <b-col
        xl="3"
        lg="4"
        md="5"
      >
        <FormCardProfileVue :loading="loading" />
      </b-col>
      <b-col
        xl="9"
        lg="8"
        md="7"
      >
        <b-tabs lazy>
          <b-tab
            v-if="verificarPermissao('ROLE_ADMIM_CONSULTAR')"
            :active="!$route.query.tab || $route.query.tab === 'pessoal'"
          >
            <template #title>
              <feather-icon icon="UserIcon" />
              <span>Pessoal</span>
            </template>
            <FormAssocianteVue :loading="loading" />
          </b-tab>

          <b-tab
            v-if="verificarPermissao('ROLE_FINAN_CONSULTAR')"
            :active="$route.query.tab === 'financeiro'"
          >
            <template #title>
              <feather-icon icon="DollarSignIcon" />
              <span>Financeiro</span>
            </template>
            <FormFinacialVue />
          </b-tab>

          <b-tab v-if="verificarPermissao('ROLE_ATEND_CONSULTAR')">
            <template #title>
              <feather-icon icon="PhoneIcon" />
              <span>Atendimento</span>
            </template>
            <FormAttendanceVue />
          </b-tab>

          <b-tab v-if="verificarPermissao('ROLE_ADMIM_CONSULTAR')">
            <template #title>
              <feather-icon icon="LinkIcon" />
              <span>Vinculos</span>
            </template>
            <FormLinkVue />
          </b-tab>

          <b-tab v-if="verificarPermissao('ROLE_DOCUMENTO_CONSULTAR')">
            <template #title>
              <feather-icon icon="FileTextIcon" />
              <span>Documentos</span>
            </template>
            <FormDocumentationsVue />
          </b-tab>

          <b-tab disabled>
            <template #title>
              <feather-icon icon="CalendarIcon" />
              <span>Eventos</span>
            </template>
            <FormEventsVue />
          </b-tab>

          <b-tab v-if="verificarPermissao('ROLE_PROTOCOLO_CONSULTAR')">
            <template #title>
              <feather-icon icon="FileIcon" />
              <span>Protocolos</span>
            </template>
            <FormProtocolVue />
          </b-tab>

          <b-tab v-if="verificarPermissao('ROLE_RELATORIO_CONSULTAR')">
            <template #title>
              <feather-icon icon="PrinterIcon" />
              <span>Relatorios</span>
            </template>
            <FormReportsVue />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BRow, BCol, BTabs, BTab,
} from 'bootstrap-vue'

import mixinsGlobal from '@/mixins'

const FormAssocianteVue = () => import('../associantes/forms/personal/FormAssociante.vue')
const FormFinacialVue = () => import('../associantes/forms/finance/FormFinancial.vue')
const FormAttendanceVue = () => import('../associantes/forms/attendance/FormAttendance.vue')
const FormDocumentationsVue = () => import('../associantes/forms/documentations/FormDocumentations.vue')
const FormEventsVue = () => import('../associantes/forms/events/FormEvents.vue')
const FormReportsVue = () => import('../associantes/forms/report/GridReport.vue')
const FormLinkVue = () => import('../associantes/forms/link/FormLink.vue')
const FormProtocolVue = () => import('../associantes/forms/protocol/FormProtocol.vue')
const FormCardProfileVue = () => import('../associantes/forms/personal/FormCardProfileAssociante.vue')

export default {
  components: {
    BRow,
    BCol,
    BTabs,
    BTab,
    FormAssocianteVue,
    FormFinacialVue,
    FormAttendanceVue,
    FormDocumentationsVue,
    FormEventsVue,
    FormReportsVue,
    FormCardProfileVue,
    FormLinkVue,
    FormProtocolVue,
  },
  mixins: [mixinsGlobal],
  data() {
    return {
      loading: true,
    }
  },
  async mounted() {
    this.loading = true
    const allPrimis = []
    let associatePromise = null

    try {
      // 1. Inicia todas as chamadas de combos em paralelo (independente dos dados do associado)
      if (this.verificarPermissao('ROLE_SEXO_CONSULTAR')) {
        allPrimis.push(
          this.$store.dispatch(
            'associantesAdministrativeModule/loadComboGenero',
          ),
        )
      }
      if (this.verificarPermissao('ROLE_ESTADO_CIVIL_CONSULTAR')) {
        allPrimis.push(
          this.$store.dispatch(
            'associantesAdministrativeModule/loadComboEstadoCivil',
          ),
        )
      }
      if (this.verificarPermissao('ROLE_PROFISSAO_CONSULTAR')) {
        allPrimis.push(
          this.$store.dispatch(
            'associantesAdministrativeModule/loadComboProfissoes',
          ),
        )
      }
      if (this.verificarPermissao('ROLE_NATURALIDADE_CONSULTAR')) {
        allPrimis.push(
          this.$store.dispatch(
            'associantesAdministrativeModule/loadComboNaturalidades',
          ),
        )
      }
      if (this.verificarPermissao('ROLE_NACIONALIDADE_CONSULTAR')) {
        allPrimis.push(
          this.$store.dispatch(
            'associantesAdministrativeModule/loadComboNacionalidades',
          ),
        )
      }
      if (this.verificarPermissao('ROLE_TIPO_REGISTRO_CONSULTAR')) {
        allPrimis.push(
          this.$store.dispatch(
            'associantesAdministrativeModule/loadComboTypesRegister',
          ),
        )
      }
      if (this.verificarPermissao('ROLE_UF_CONSULTAR')) {
        allPrimis.push(
          this.$store.dispatch('associantesAdministrativeModule/loadComboUfs'),
        )
      }
      if (this.verificarPermissao('ROLE_PREVIDENCIA_SOCIAL_CONSULTAR')) {
        allPrimis.push(
          this.$store.dispatch(
            'associantesAdministrativeModule/loadComboPrevidenciaSocial',
          ),
        )
      }
      if (this.verificarPermissao('ROLE_TIPO_ENDERECO_CONSULTAR')) {
        allPrimis.push(
          this.$store.dispatch(
            'associantesAdministrativeModule/loadComboTipoEndereco',
          ),
        )
      }
      if (this.verificarPermissao('ROLE_SITUACAO_REGISTRO_CONSULTAR')) {
        allPrimis.push(
          this.$store.dispatch(
            'associantesAdministrativeModule/loadComboSituacaoRegistro',
          ),
        )
      }
      if (this.verificarPermissao('ROLE_TIPO_FAIXA_CONSULTAR')) {
        allPrimis.push(
          this.$store.dispatch('combosModule/loadComboFaixaContribuicao'),
        )
      }

      // 2. Inicia a busca dos dados do associado em paralelo com os combos
      if (this.verificarPermissao('ROLE_ASSOCIADO_CONSULTAR')) {
        associatePromise = this.$store.dispatch(
          'associantesAdministrativeModule/getAssocianteID',
          this.$route.params.id,
        )
      }

      // 3. Aguarda o término de todas as requisições paralelas
      await Promise.all(
        [...allPrimis, associatePromise].filter(p => p !== null),
      )

      // 4. Se buscou o associado, processa os dados e prepara a edição
      if (associatePromise) {
        const response = await associatePromise // Já resolvido pelo Promise.all
        const objectAssociate = response.data
        if (objectAssociate.foto) {
          objectAssociate.foto = `data:image/jpeg;base64,${objectAssociate.foto}`
        }
        await this.$store.dispatch(
          'associantesAdministrativeModule/prepareToEditFullAssociante',
          objectAssociate,
        )
      }

      this.loading = false
    } catch (error) {
      console.error(error)
      this.MensagemError('Error', 'Erro ao carregar dados da tela!')
      this.loading = false
      this.$router.go(-1)
    }
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
